export default __webpack_public_path__ + "static/media/video.f0b05224.mp4";